"use client";

import { Instagram, Linkedin, Music, Podcast, Video } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
const studioLinks = [{
  label: "Roster",
  to: "/TheNexusPage"
}, {
  label: "Tournaments",
  to: "/TheGridPage"
}, {
  label: "Highlights",
  to: "/TheHolodeckPage"
}, {
  label: "Wallpapers",
  to: "/TheHolodeckPage"
}, {
  label: "Merchandise",
  to: "/TheGridPage"
}, {
  label: "Pro-Play",
  to: "/TheNexusPage"
}];
const shopLinks = [{
  label: "All Gear",
  to: "/TheGridPage"
}, {
  label: "Jerseys",
  to: "/TheGridPage"
}, {
  label: "Peripherals",
  to: "/TheGridPage"
}, {
  label: "Accessories",
  to: "/TheGridPage"
}, {
  label: "Limited Drops",
  to: "/TheGridPage"
}];
const learnLinks = [{
  label: "Community",
  to: "/TheNexusPage"
}, {
  label: "Discord",
  to: "#"
}, {
  label: "Schedules",
  to: "/TheGridPage"
}, {
  label: "Events",
  to: "/TheGridPage"
}, {
  label: "FAQ",
  to: "#"
}, {
  label: "Support",
  to: "#"
}];
const socials = [{
  label: "LinkedIn",
  icon: Linkedin,
  to: "#"
}, {
  label: "Spotify",
  icon: Music,
  to: "#"
}, {
  label: "Apple Podcasts",
  icon: Podcast,
  to: "#"
}, {
  label: "Vimeo",
  icon: Video,
  to: "#"
}, {
  label: "Instagram",
  icon: Instagram,
  to: "#"
}];
const legalLinks = [{
  label: "PRIVACY",
  to: "#"
}, {
  label: "TERMS",
  to: "#"
}, {
  label: "CREDITS",
  to: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[...Array(5)].map((_, i) => <div data-index={i} key={i} className="h-4 w-32 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="group relative inline-block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
            <span className="relative">
              {item.label}
              <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-primary transition-all duration-500 group-hover:w-full" />
            </span>
          </Link>
        </li>)}
    </ul>;
}
export default function NexusFooter() {
  return <section data-section-id="3976" id="nexus-footer" className="relative bg-background text-foreground overflow-hidden border-t border-border">
      {}
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {}
          <div className="md:col-span-5 lg:col-span-4 flex flex-col gap-8">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-20 w-auto" />
            </Link>

            <p className="text-xl md:text-2xl italic leading-snug max-w-[320px] text-foreground" style={{
            fontFamily: "var(--font-default)"
          }}>
              Pixel Force: Dominating the digital arena, one frame at a time.
            </p>

            <div className="flex flex-col gap-2 text-xs tracking-widest text-muted-foreground" style={{
            fontFamily: "var(--font-mono)"
          }}>
              <p className="uppercase">
                HQ &mdash; NEON DISTRICT 01
              </p>
              <p className="uppercase">
                TRAINING &mdash; CYBER CORE HUB
              </p>
              <p className="uppercase pt-2">+1 800-PIXEL-FORCE</p>
              <Link to="mailto:contact@pixelforce.gg" className="uppercase hover:text-primary transition-colors duration-300 w-fit">
                COMMAND@PIXELFORCE.GG
              </Link>
            </div>
          </div>

          {}
          <div className="md:col-span-3 lg:col-span-3">
            <h3 className="text-xs tracking-[0.2em] text-primary mb-6 uppercase font-default font-medium" style={{
            fontFamily: "var(--font-mono)"
          }}>
              ORGANIZATION
            </h3>
            <ul className="flex flex-col gap-3">
              {studioLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.to} className="group relative inline-block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                    <span className="relative">
                      {link.label}
                      <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-primary transition-all duration-500 group-hover:w-full" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-2 lg:col-span-2">
            <h3 className="text-xs tracking-[0.2em] text-primary mb-6 uppercase font-medium" style={{
            fontFamily: "var(--font-mono)"
          }}>
              ARMORY
            </h3>
            <ul className="flex flex-col gap-3">
              {shopLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.to} className="group relative inline-block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                    <span className="relative">
                      {link.label}
                      <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-primary transition-all duration-500 group-hover:w-full" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="md:col-span-2 lg:col-span-3">
            <h3 className="text-xs tracking-[0.2em] text-primary mb-6 uppercase font-medium" style={{
            fontFamily: "var(--font-mono)"
          }}>
              NETWORK
            </h3>
            <MenuProvider menu_id="34">
              <FooterMenuConsumer />
            </MenuProvider>
            <ul className="flex flex-col gap-3 mt-3">
              {learnLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.to} className="group relative inline-block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">
                    <span className="relative">
                      {link.label}
                      <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-primary transition-all duration-500 group-hover:w-full" />
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>
      </div>

      {}
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-8">
        <div className="border-t border-b border-border py-6">
          <svg className="w-full h-12" viewBox="0 0 1200 48" preserveAspectRatio="none" aria-hidden="true">
            <path d="M0,24 Q30,8 60,24 T120,24 T180,24 T240,24 T300,24 T360,24 T420,24 T480,24 T540,24 T600,24 T660,24 T720,24 T780,24 T840,24 T900,24 T960,24 T1020,24 T1080,24 T1140,24 T1200,24" fill="none" stroke="var(--primary)" strokeWidth="1.5" strokeOpacity="0.5" strokeLinecap="round">
              <animate attributeName="d" dur="6s" repeatCount="indefinite" values="
                  M0,24 Q30,8 60,24 T120,24 T180,24 T240,24 T300,24 T360,24 T420,24 T480,24 T540,24 T600,24 T660,24 T720,24 T780,24 T840,24 T900,24 T960,24 T1020,24 T1080,24 T1140,24 T1200,24;
                  M0,24 Q30,40 60,24 T120,24 T180,24 T240,24 T300,24 T360,24 T420,24 T480,24 T540,24 T600,24 T660,24 T720,24 T780,24 T840,24 T900,24 T960,24 T1020,24 T1080,24 T1140,24 T1200,24;
                  M0,24 Q30,8 60,24 T120,24 T180,24 T240,24 T300,24 T360,24 T420,24 T480,24 T540,24 T600,24 T660,24 T720,24 T780,24 T840,24 T900,24 T960,24 T1020,24 T1080,24 T1140,24 T1200,24
                " />
            </path>
          </svg>
        </div>
      </div>

      {}
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pb-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {}
          <p className="text-[10px] tracking-[0.2em] text-muted-foreground uppercase order-1" style={{
          fontFamily: "var(--font-mono)"
        }}>© 2026 PIXEL FORCE ESPORTS</p>

          {}
          <div className="flex items-center gap-5 order-3 md:order-2">
            {socials.map((social, i) => {
            const Icon = social.icon;
            return <Link data-index={i} key={social.label} to={social.to} newTab aria-label={social.label} className="text-muted-foreground hover:text-primary transition-colors duration-300">
                  <Icon className="w-[18px] h-[18px]" strokeWidth={1.5} />
                </Link>;
          })}
          </div>

          {}
          <div className="flex items-center gap-4 order-2 md:order-3 text-[10px] tracking-[0.2em] uppercase" style={{
          fontFamily: "var(--font-mono)"
        }}>
            {legalLinks.map((link, i) => <span data-index={i} key={link.label} className="flex items-center gap-4">
                <Link to={link.to} className="text-muted-foreground hover:text-foreground transition-colors duration-300">
                  {link.label}
                </Link>
                {i < legalLinks.length - 1 && <span className="text-muted-foreground/40">/</span>}
              </span>)}
          </div>
        </div>
      </div>

      {}
      <div className="relative w-full overflow-hidden pointer-events-none select-none" aria-hidden="true">
        <div className="text-center leading-none whitespace-nowrap" style={{
        fontFamily: "var(--font-default)",
        fontSize: "clamp(120px, 28vw, 280px)",
        fontWeight: 800,
        color: "hsl(240 10% 8%)",
        transform: "translateY(40%)",
        letterSpacing: "-0.04em"
      }}>
          PIXEL
        </div>
      </div>
    </section>;
}